module.exports = __webpack_public_path__ + "static/img/review-like-active.6b5d8e3d.svg";